import { Component, Input, OnInit } from '@angular/core'
import { BlockDataService } from 'src/app/block-services/block-data.service'
import { BlockFieldsService } from 'src/app/block-services/block-fields.service'
import { BuilderService } from 'src/app/builder-services/builder.service'

@Component({
  selector: 'block-announcement-bar',
  templateUrl: './block-announcement-bar.component.html',
  styleUrls: ['./block-announcement-bar.component.scss']
})
export class BlockAnnouncementBarComponent implements OnInit {
  @Input() importedBlockData: any
  @Input() builderType: 'mobile' | 'website' = 'mobile'

  blockData: any
  blockId = ''
  previewBlock = false
  previewFields = false
  styleFields = false

  constructor(
    private blockDataService: BlockDataService,
    private blockFieldsService: BlockFieldsService,
    public builderService: BuilderService
  ) {}

  ngOnInit() {
    if (this.importedBlockData) {
      this.previewBlock = true
      this.previewFields = false
      this.styleFields = false
    }
    this.blockData = this.importedBlockData ?? this.blockFieldsService.getAnnouncementBarBlockFields()
    if (this.importedBlockData?.id) {
      this.blockId = this.importedBlockData.id
    } else if (!this.blockId) {
      this.blockId = this.blockDataService.getUniqueId(2)
    }
  }

  addBlockToPreview(initial: any = '') {
    const blockData = {
      component: BlockAnnouncementBarComponent,
      index: 'latest',
      element: this,
      initial
    }
    this.blockDataService.sendBlockData(blockData)
    this.builderService.blocksCollapsed = true
  }

  appendBlock($event: any) {
    const clonedBlockData = { ...this.blockData }
    this.blockId = this.blockDataService.appendBlocksData(clonedBlockData)
    this.addBlockToPreview()
  }

  showData(blockId: any) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      blockId = this.blockDataService.getLatestBlockId()
    }
    this.blockFieldsService.clickedBlockId = blockId
    this.blockDataService.sendCurrentBlock(BlockAnnouncementBarComponent)
  }

  deleteBlock(blockId: any) {
    this.blockDataService.removeBlockData(blockId)
  }

  getBlockFields(id: string) {
    if (this.importedBlockData) return this.importedBlockData
    return this.blockDataService.getSelectedBlockData(id)
  }

  checkSidebar() {
    return !this.previewBlock && !this.previewFields && !this.styleFields
  }

  checkPreview() {
    return this.previewBlock && !this.previewFields && !this.styleFields
  }

  checkData() {
    return this.previewFields
  }

  checkStyle() {
    return this.styleFields && !this.previewFields && !this.previewBlock
  }

  checkSettings() {
    return !this.checkSidebar() && !this.checkPreview()
  }

  showDataTab() {
    this.previewBlock = false
    this.previewFields = true
    this.styleFields = false
  }

  showStyleTab() {
    this.previewBlock = false
    this.previewFields = false
    this.styleFields = true
  }

  /**
   * Handle changes from the TinyMCE message editor (mirrors block-text's textChange)
   */
  textChange($event: any, blockId: any) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) return
    const fields = this.getBlockFields(blockId)
    const tinyMCEValue = $event.event.currentTarget.body.innerHTML
    fields.data = { ...fields.data, text: tinyMCEValue }
  }

  queryChange(query: string, blockId: any, $event: any, type: string) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) return
    const fields = this.getBlockFields(blockId)
    let value: any = ''
    if (type === 'select') {
      value = $event.value
    } else if (type === 'text') {
      value = $event.currentTarget.value
    } else if (type === 'toggle') {
      value = $event.checked
    }
    fields.data = { ...fields.data, [query]: value }
  }

  styleChange(style: string, blockId: any, $event: any, type: string) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) return
    const fields = this.getBlockFields(blockId)
    const cloned = { ...fields.style }
    cloned[style] = type === 'text' ? $event.currentTarget.value : ($event.value ?? $event.currentTarget?.value)
    fields.style = cloned
  }

  /**
   * Dedicated handler for the animation speed slider - stores a raw number of seconds,
   * unlike the generic style slider handling elsewhere in the app which appends "px".
   */
  animationSpeedChange($event: any, blockId: any) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) return
    const fields = this.getBlockFields(blockId)
    const rawValue = $event.value ?? $event.currentTarget?.value
    fields.style = { ...fields.style, animationSpeed: Number(rawValue) || 20 }
  }
}
